import { useFaqSkdClaimAssignmentQuery } from '@/api/getters';
import Accordion from '@/components/ui/Accordion';
import cn from '@/utils/cn';

const FaqClaimPanel = ({
  serviceId,
  className,
}: {
  serviceId: number;
  className?: string;
}) => {
  const { data: questions } = useFaqSkdClaimAssignmentQuery();

  return questions && questions[serviceId] && questions[serviceId]?.length ? (
    <div
      className={cn(
        'flex w-full min-w-[300px] max-w-full flex-col gap-2.5 rounded-lg bg-gray-100 px-3.5 py-4 xs:min-w-[440px] lg:w-[980px] lg:gap-y-[30px] lg:rounded-[10px] lg:p-10',
        className
      )}
    >
      <div className="flex flex-col gap-6 rounded-md bg-gray-200 px-[14px] py-4 pt-8 sm:px-6 lg:p-10">
        <Accordion
          className="p-0 lg:p-0"
          eyebrow="FAQ"
          title="Najczęściej zadawane pytania"
          data={questions[serviceId]}
        />
      </div>
    </div>
  ) : null;
};

export default FaqClaimPanel;
